


























import { Component, Prop, Provide, Vue, Emit } from 'vue-property-decorator';
import StatsTravelContent from './StatsTravelContent.vue';
import { EventBus, TypeEventBus } from '../../../core/utils';
import { HistoricalParams } from '../../../core/models';

@Component({
    components: {
        StatsTravelContent
    }
})
export default class StatsTravel extends Vue {
    title: string = 'Estadísticas del recorrido: ';
    @Prop() tooltip: boolean;
    @Prop() visible: boolean;
    @Prop() headers: any;
    @Prop() items: any;
    @Prop() vehicles: any;

    @Emit()
    closeModal() {}
}
